module.exports = __webpack_public_path__ + "img/GamerCity.7b076747.jpeg";